export const openEngineData = {
  challenges: [
    {
      iconSrc: require("../assets/icons/rigid-infrastructure.svg"),
      title: "Rigid Infrastructures",
      tags: ["Data Engineers", "Data Analysts"],
      description:
        "Traditional architectures struggle with downscaling, causing high costs and inefficiencies during high-demand tasks.",
    },
    {
      iconSrc: require("../assets/icons/operational-inefficiencies.svg"),
      title: "Operational Inefficiencies",
      tags: ["Head of Analytics", "CTO"],
      description:
        "Frequent downtimes and resource conflicts delay crucial insights, impacting data team performance.",
    },
    {
      iconSrc: require("../assets/icons/cost-and-revenue-impact.svg"),
      title: "Cost and Revenue Impact",
      tags: ["Head of Engineering", "CTO"],
      description:
        "Upgrading systems to handle occasional spikes in demand can result in excessive spending.",
    },
  ],
  features: [
    {
      image: require("../assets/images/scalability.svg"),
      title: "Scalability",
      description:
        "Spin-up compute resources for demanding tasks and scale down post-completion.",
    },
    {
      image: require("../assets/images/separation.svg"),
      title: "Separation",
      description:
        "Isolate intensive workloads to maintain stable system performance.",
    },
    {
      image: require("../assets/images/availability.svg"),
      title: "Availability",
      description:
        "Ensure continuous service availability even during system upgrades.",
    },
    {
      image: require("../assets/images/cost-efficiency.svg"),
      title: "Cost Efficiency",
      description: "Optimize resource usage to minimize operational costs.",
    },
    {
      image: require("../assets/images/customization.svg"),
      title: "Customisation",
      description:
        "Tailor resource allocation and permissions to suit specific team needs.",
      link: "#",
    },
    {
      image: require("../assets/images/resource-management.svg"),
      title: "Resource Management",
      description:
        "Allocate resources based on team requirements for efficient operation.",
      link: "#",
    },
  ],
  videos: [
    {
      title: "Separation of Resources",
      videoSrc: `<iframe
    src="https://demo.arcade.software/qHLLRTv9CAiN8Xk3Y2S0?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true"
    title="Separation Of Resources"
    frameborder="0"
    loading="lazy"
    webkitallowfullscreen
    mozallowfullscreen
    allowfullscreen
    allow="clipboard-write"
    style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; color-scheme: light;"
  >
  </iframe>`,
      previewImage: require("../assets/images/openengine-video-1.svg"),
    },
    {
      title: "Connecting BI Tools",
      videoSrc: `<iframe
    src="https://demo.arcade.software/uMSEnJZ2FViEyPHmSF5j?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true"
    title="Open Engine :BI Tools "
    frameborder="0"
    loading="lazy"
    webkitallowfullscreen
    mozallowfullscreen
    allowfullscreen
    allow="clipboard-write"
    style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; color-scheme: light;"
  ></iframe>`,
      previewImage: require("../assets/images/openengine-video-2.svg"),
    },
  ],
  benchmarks: {
    comparisonItems: [
      {
        images: require("../assets/images/snowflake.svg"),
        title: "2X",
        description: "less costly than snowflake*",
        textColor: "benchmark-primary",
      },
      {
        images: require("../assets/images/amazon-redshift.svg"),
        title: "1.6X",
        description: "less costly than Redshift*",
        textColor: "benchmark-primary",
      },
      {
        images: require("../assets/images/postgres.svg"),
        title: "55X",
        description: "more powerful than Postgres SQL*",
        textColor: "benchmark-secondary",
      },
      {
        images: require("../assets/images/mysql.svg"),
        title: "162X",
        description: "more powerful than MySQL*",
        textColor: "benchmark-secondary",
      },
    ],
    coparisonGraphs: [
      {
        image: require("../assets/images/open-engine-graph1.png"),
        title: "Avg Price/Month",
      },
      {
        image: require("../assets/images/open-engine-graph2.png"),
        title: "Database Engine Performance (%)",
      },
    ],
  },
  testimonialCols: [
    [
      {
        name: "Dhruvil Dhankani",
        designation: "Principal Data Engineer",
        image: require("../assets/images/dhruvil-dhankani.png"),
        review: `<p><b>"</b>I find OpenEngine to be a valuable addition to the data analytics toolkit. It streamlines daily workflows, offering significant time and cost savings while empowering data teams to tackle complex analytics tasks with ease. The flexibility it provides is particularly impressive.</p><p>In the future, I’d love to see more pre-emptive recommendations from OpenEngine on when to use ad-hoc computing versus when a server upgrade might be necessary<b>"</b></p>`,
      },
    ],
    [
      {
        name: "Aakarsh Yadav",
        designation: "Founder at Hushl",
        image: require("../assets/images/aakarsh-yadav.jpeg"),
        review: `<p><b>"</b>As a growing startup, we struggled with system downtimes during crucial analytics runs. <b>OpenEngine changed that completely</b> - we've gone from experiencing downtime 2-3 times a week to hardly 1 incident in the past month.</p><p> Our team now <b>saves about 10 hours weekly</b> that were previously spent troubleshooting and restarting queries.<b>"</b></p>`,
      },
      {
        name: "Vaibhav Dusad",
        designation: "Co-founder at SurgeGrowth",
        image: require("../assets/images/vaibhav-dusad.jpeg"),
        review: `<p><b>"</b>We used to limit our clients' queries to avoid overloads. With OpenEngine, those limits are gone. We've doubled our user base without adding any new hardware. <b>It's been a game-changer for our small team.</b><b>"</b></p>`,
      },
    ],
    [
      {
        name: "Akshay Hangloo",
        designation: "Co-founder at Zeroztep",
        image: require("../assets/images/akshay-hangloor.jpeg"),
        review: `<p><b>"</b>We've scaled our <b>daily query volume from 10,000 to 35,000</b> without increasing costs or hardware. It's ability to spin up machines from <b>16GB to 256GB</b> is perfect for running complex jobs without impacting our infrastructure. OpenEngine’s dynamic scaling has also reduced our <b>cloud costs by 20%</b>, all while improving performance. With granular access control, I can ensure that only the right team members have access to higher resources.</p><p><b>OpenEngine has been a game changer for managing our data pipelines alongside Datazip.</b><b>"</b></p>`,
      },
    ],
  ],
  betaUsers: [
    {
      name: "PagarBook",
      image: require("../assets/images/pagarbook.svg"),
    },
    {
      name: "Limechat",
      image: require("../assets/images/limechat.webp"),
    },
    {
      name: "Hushl",
      image: require("../assets/images/hushl.svg"),
    },
    {
      name: "Delcaper",
      image: require("../assets/images/delcaper.png"),
    },
    {
      name: "SurgeGrowth",
      image: require("../assets/images/surgegrowth.png"),
    },
  ],
};

export const landingPageData = {
  partners: [
    {
      title: "vyapar",
      src: require("../assets/images/vyapar.svg"),
    },
    {
      title: "moengage",
      src: require("../assets/images/moengage.svg"),
    },
    {
      title: "growpital",
      src: require("../assets/images/growpital.svg"),
    },
    {
      title: "limechat",
      src: require("../assets/images/limechat.webp"),
    },
    {
      title: "pagarbook",
      src: require("../assets/images/pagarbook.svg"),
    },
    {
      title: "kenko",
      src: require("../assets/images/kenkohealth.svg"),
    },
  ],
};

// Helper function to generate video embed source URL
export const getVideoEmbedSrc = (videoSrc, isYoutubeUrl, isCustomEmbed) => {
  if (!isYoutubeUrl && !isCustomEmbed) {
    return videoSrc;
  }
  if (isYoutubeUrl) {
    return `${videoSrc}?autoplay=1&enablejsapi=1&origin=${window.location.origin}&widgetid=10&rel=0`;
  }
  // Custom embed code
  return videoSrc;
};
